export default class Buttons {
	constructor() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach((button) => {

			const text = `<span class='label-cta'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if (button.classList.contains('btn-go') || button.classList.contains('btn-back')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="50" height="54" viewBox="0 0 50 54" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7803 49.6981L23.5981 53.5714L50 26.7857L23.5981 0L19.7803 3.87236L39.6649 24.046L0 24.046L0 29.5239L39.6649 29.5239L19.7803 49.6981Z" fill="white"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-download')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-gallery')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-lang')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if (button.classList.contains('btn-reset')) {
				const element = document.createElement("span");
				element.innerHTML = `<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.4277 1.47282L6.47508 5.42367L10.3415 9.28962L10.4277 9.37453L10.3415 9.45944L9.46273 10.3381L9.37781 10.4243L9.29289 10.3381L5.42773 6.47217L1.56258 10.3381L1.47894 10.4243L1.39402 10.3381L0.513941 9.45944L0.427734 9.37453L0.513941 9.28962L4.3791 5.42367L0.427734 1.47282L1.47637 0.424316L5.42773 4.37517L9.38039 0.424316L10.4277 1.47282Z" fill="white" stroke="#00004B" stroke-width="0.6"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}
		});
	}
}
